'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.transformData = transformData;
function transformData(jsonData, definition) {

	var chartData = {
		labels: [],
		datasets: []
	};

	for (var i = 0; i < definition.dataPoints.length; i++) {
		chartData.datasets.push({
			label: definition.dataPoints[i],
			backgroundColor: 'rgba(0,0,0,0.5)',
			borderColor: 'rgba(0,0,0,1)',
			borderWidth: 2,
			data: []
		});
	}

	for (var j = 0; j < jsonData.length; j++) {

		var label = [];
		for (var i = 0; i < definition.groupBy.length; i++) {
			label.push(jsonData[j][definition.groupBy[i]]);
		}
		label = label.join(' / ');
		chartData.labels.push(label);
		for (var i = 0; i < definition.dataPoints.length; i++) {
			chartData.datasets[i].data.push(jsonData[j][definition.dataPoints[i]]);
		}
	}

	return chartData;
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/charts/helpers.js
// module id = 562
// module chunks = 0